export { EXPERTISE } from './expertise';
export { THEMATIC } from './thematic';
export { COMMON_THEMATIC } from './common-thematic';
export { PUBLICATION } from './publication';
export { FINANCIAL_PUBLICATION } from './financial-publication';
export { CATEGORY } from './category';
export {
  REGION,
  REGION_NATIONAL,
  REGION_INTERNATIONAL,
  isNationalRegion,
  isInternationalRegion,
} from './region';
export { CLASSIFICATION } from './classification';

export enum FILTER {
  CATEGORY = 'category',
  CLASSIFICATION = 'classification',
  COMMON_THEMATIC = 'commonThematic',
  EXPERTISE = 'expertise',
  MEDIA_THEMATIC = 'mediaThematic',
  MEDIA_TYPE = 'mediaType',
  PUBLICATION = 'publication',
  FINANCIAL_PUBLICATION = 'financialPublication',
  REGION = 'region',
  THEMATIC = 'thematic',
  DATE_RANGE = 'dateRange',
  START_DATE = 'startDate',
  END_DATE = 'endDate',
  NATIONAL = 'national',
  INTERNATIONAL = 'international',
}
